import { render, staticRenderFns } from "./DpSettings.vue?vue&type=template&id=52994582&"
import script from "./DpSettings.vue?vue&type=script&lang=ts&"
export * from "./DpSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports